import { styled } from '@/styled-system/jsx';

export const StyledHdpContainer = styled('div', {
  base: {
    WebkitOverflowScrolling: 'auto',
    overflow: 'visible',
    background: 'hpxWhite',
    height: '100%',
    position: 'relative',
    marginTop: 'token(sizes.hdpNavBarHeightMd)',
    xl: {
      marginTop: '42px',
    },
    xxl: {
      marginTop: '48px',
    },
  },
});

// Tour Status Module Container
export const StyledTourStatusModuleContainer = styled('div', {
  base: {
    boxSizing: 'border-box',
    margin: '0',
  },
});

// Buttons Section Container with horizontal padding
export const StyledButtonsSectionContainer = styled('section', {
  base: {
    paddingLeft: '16px',
    paddingRight: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    '& > *': {
      maxWidth: '400px',
      width: '100%',
    },
    md: {
      '& > *': {
        maxWidth: '399px',
      },
    },
    xxl: {
      flexDirection: 'row',
      alignItems: 'stretch',
      gap: '32px',
      '& > *': {
        maxWidth: '274px',
      },
    },
  },
});
